module.exports = __webpack_public_path__ + "media/images/features/refund/icon-step-02-5bf9f01a9c49655046094e1ca6e81020.svg";